
<div>
  <el-cascader popper-class="city-el-cascader" :placeholder="placeholderWord" style="width: 400px" clearable
    v-model="editItem.values" :props="cascaderProps" @change="cascaderChange" size="medium"></el-cascader>
</div>
